import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=22e6a10e&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/compatibility.css?vue&type=style&index=0&lang=css&"
import style1 from "./Result.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports